import { call, put, select, takeEvery } from 'redux-saga/effects';

import { request } from 'components/Fetch';
import urls from 'config/urls';
import { QuickpayConstants } from 'constants/quickpay';
import { getPaymentAccountsAction } from 'actions/quickpay';

function* getQuickpay(action) {
  yield call(request({
    type: QuickpayConstants.GET_QUICKPAY,
    method: 'GET',
    url: urls.getQuickpay(),
  }), action);
}

function* getPaymentAccounts(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.GET_PAYMENT_ACCOUNTS,
    method: 'GET',
    url: urls.getQuickpayPaymentAccounts(loanId),
  }), action);
}

function* addPaymentAccounts(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.ADD_PAYMENT_ACCOUNT,
    method: 'POST',
    url: urls.getQuickpayPaymentAccounts(loanId),
  }), action);
  yield put(getPaymentAccountsAction());
}

function* getQuickpayStatus(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.GET_STATUS,
    method: 'GET',
    url: urls.getQuickpayStatus(loanId),
  }), action);
}

function* makeQuickpayPayment(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.MAKE_QUICKPAY_PAYMENT,
    method: 'POST',
    url: urls.makeQuickpayPayment(loanId),
  }), action);
}

function* getQuickpayAutopays(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.GET_AUTOPAYS,
    method: 'GET',
    url: urls.getQuickpayAutopays(loanId),
  }), action);
}

function* scheduleQuickpayAutopay(action) {
  const loanId = yield select((state) => state.quickpay.data.loanId);
  yield call(request({
    type: QuickpayConstants.SCHEDULE_AUTOPAY,
    method: 'POST',
    url: urls.getQuickpayAutopays(loanId),
  }), action);
}

function* validateBankRoutingNumber(action) {
  const { routingNumber } = action.payload;
  yield call(request({
    type: QuickpayConstants.VALIDATE_BANK_ROUTING_NUMBER_QUICKPAY,
    method: 'GET',
    url: urls.validateRoutingNumber({ routingNumber, isQuickpay: true }),
  }), action);
}

const quickpaySaga = function* () {
  yield takeEvery(QuickpayConstants.GET_QUICKPAY, getQuickpay);
  yield takeEvery(QuickpayConstants.GET_PAYMENT_ACCOUNTS, getPaymentAccounts);
  yield takeEvery(QuickpayConstants.ADD_PAYMENT_ACCOUNT, addPaymentAccounts);
  yield takeEvery(QuickpayConstants.GET_STATUS, getQuickpayStatus);
  yield takeEvery(QuickpayConstants.MAKE_QUICKPAY_PAYMENT, makeQuickpayPayment);
  yield takeEvery(QuickpayConstants.GET_AUTOPAYS, getQuickpayAutopays);
  yield takeEvery(QuickpayConstants.SCHEDULE_AUTOPAY, scheduleQuickpayAutopay);
  yield takeEvery(QuickpayConstants.VALIDATE_BANK_ROUTING_NUMBER_QUICKPAY, validateBankRoutingNumber);
};

export default quickpaySaga;
